import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSystemSettingType, TSystemSettingTypeUpdate, TSystemSettingTypeResponse, adaptSystemSettingTypeFromResponse } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_SYSTEM_SETTINGS_TYPES } from '../../backend-paths';


export const systemSettingTypeUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_SYSTEM_SETTINGS_TYPES}/:id`,
	(payload: TSystemSettingTypeUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ADMIN_SYSTEM_SETTINGS_TYPES}/${id}`;

		return HttpService.put<TSystemSettingTypeResponse>(path, data).then(result => {
			return adaptSystemSettingTypeFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TSystemSettingType> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const systemSettingTypeUpdateSlice = createSlice({
	name: 'systemSettingTypeUpdateSlice',
	initialState,
	reducers: {
		clearSystemSettingTypeUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[systemSettingTypeUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[systemSettingTypeUpdateApi.fulfilled.type]: (state, action: PayloadAction<TSystemSettingType>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[systemSettingTypeUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useSystemSettingTypeUpdateSelector = () => useAppSelector(state => state[systemSettingTypeUpdateSlice.name]);

export const { clearSystemSettingTypeUpdate } = systemSettingTypeUpdateSlice.actions;
